import { render, staticRenderFns } from "./empty-layout.vue?vue&type=template&id=72f11ba9&"
import script from "./empty-layout.vue?vue&type=script&lang=js&"
export * from "./empty-layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports